import { render, staticRenderFns } from "./SettingsCosts.vue?vue&type=template&id=d0d19428&scoped=true&"
import script from "./SettingsCosts.vue?vue&type=script&lang=js&"
export * from "./SettingsCosts.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCosts.vue?vue&type=style&index=0&id=d0d19428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d19428",
  null
  
)

export default component.exports